import { Link, NavLink } from "react-router-dom";
import { useState } from "react";
import { Menu } from "lucide-react";
import { Sheet, SheetContent, SheetTrigger } from "@/components/ui/sheet";

const LOGO = "https://customer-assets-cm19k8pv.emergentagent.net/job_harvest-books-9/artifacts/7sqc5jtf_LOGO%20Harvest%20Books%20-%20H%20-%20Blue%20Gradient.webp";

const NAV = [
  { label: "Inicio", to: "/" },
  { label: "Nosotros", to: "/nosotros" },
  { label: "Autores", to: "/autores" },
  { label: "Libros", to: "/libros" },
  { label: "Ebooks", to: "/ebooks" },
  { label: "Libros en tu Iglesia", to: "/libros-en-tu-iglesia" },
  { label: "Distribuidores", to: "/distribuidores" },
  { label: "Publica", to: "/publica-con-harvest" },
  { label: "Gratis", to: "/gratis" },
  { label: "Contacto", to: "/contacto" },
];

export default function Header() {
  const [open, setOpen] = useState(false);

  return (
    <header className="sticky top-0 z-50 bg-[#f5f4f1]/85 backdrop-blur-md border-b border-[#0f2544]/10" data-testid="site-header">
      <div className="max-w-[1500px] mx-auto px-4 sm:px-6 lg:px-10 h-16 md:h-20 flex items-center justify-between gap-6">
        <Link to="/" className="flex items-center" data-testid="header-logo">
          <img src={LOGO} alt="Editorial Harvest" className="h-10 md:h-12 w-auto" />
        </Link>

        <nav className="hidden xl:flex items-center gap-5 2xl:gap-7">
          {NAV.map((n) => (
            <NavLink
              key={n.to}
              to={n.to}
              end={n.to === "/"}
              className={({ isActive }) =>
                `text-[0.82rem] font-medium hv-link-underline transition-colors ${isActive ? "text-[#1f44e0]" : "text-[#0f2544] hover:text-[#1f44e0]"}`
              }
              data-testid={`nav-${n.to === "/" ? "home" : n.to.slice(1)}`}
            >
              {n.label}
            </NavLink>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <Sheet open={open} onOpenChange={setOpen}>
            <SheetTrigger asChild>
              <button className="xl:hidden p-2 text-[#0f2544]" aria-label="Menú" data-testid="mobile-menu-trigger"><Menu size={24} /></button>
            </SheetTrigger>
            <SheetContent side="right" className="w-[300px] bg-[#f5f4f1] border-l border-[#0f2544]/10 p-0">
              <div className="px-6 py-5 border-b border-[#0f2544]/10"><img src={LOGO} alt="Editorial Harvest" className="h-9 w-auto" /></div>
              <nav className="flex flex-col px-6 py-5">
                {NAV.map((n) => (
                  <NavLink key={n.to} to={n.to} end={n.to === "/"} onClick={() => setOpen(false)}
                    className={({ isActive }) => `py-3.5 text-lg font-serif font-medium border-b border-[#0f2544]/8 ${isActive ? "text-[#1f44e0]" : "text-[#0f2544]"}`}
                    data-testid={`mobile-nav-${n.to === "/" ? "home" : n.to.slice(1)}`}>
                    {n.label}
                  </NavLink>
                ))}
              </nav>
            </SheetContent>
          </Sheet>
        </div>
      </div>
    </header>
  );
}
